import React, { useEffect } from "react";
import "./drawer.css";
import Icon from "../icon/icon";

// Drawer component props interface
export interface DrawerProps {
  title: string;
  children: React.ReactNode;
  onClose: () => void;
  isOpen: boolean;
  width?: number;
  onSubmit?: () => void;
}

const Drawer: React.FC<DrawerProps> = ({
  title,
  children,
  onClose,
  isOpen,
  width = 500,
  onSubmit,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleContentClick = (e: React.MouseEvent<HTMLDivElement>): void => {
    e.stopPropagation();
  };

  return (
    <div className="drawer-overlay">
      <div
        className="drawer"
        style={{ width: `${width}px` }}
        onClick={handleContentClick}
      >
        <div className="drawer__header">
          <h3 className="drawer__title">{title}</h3>
          <button className="drawer__close" onClick={onClose}>
            <Icon name="close" size="small" />
          </button>
        </div>
        <div className="drawer__content">{children}</div>
      </div>
    </div>
  );
};

export default Drawer;
